import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="404 | Not Found" description="The page you are looking for does not exist." path="/" noindex />
      <section className="relative min-h-[60vh] bg-obsidian border-b border-white/10">
      <div className="absolute inset-0 bg-grid opacity-30" />
      <div className="relative max-w-3xl mx-auto px-5 lg:px-8 py-28 text-center">
        <div className="chip text-neon-green">&gt; /404</div>
        <h1 className="mt-4 font-display font-black text-6xl lg:text-8xl text-white tracking-tighter leading-none">
          4<span className="text-glow-green text-neon-green">0</span>4
        </h1>
        <p className="mt-4 font-mono text-white/60">
          signal_lost, route not in the system.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-neon-green text-obsidian px-6 py-3 text-sm font-mono font-bold uppercase tracking-widest"
            data-testid="notfound-home"
          >
            Return home
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 border border-white/20 text-white px-6 py-3 text-sm font-mono uppercase tracking-widest hover:border-neon-cyan hover:text-neon-cyan transition-colors"
          >
            Contact us
          </Link>
        </div>
      </div>
    </section>
    </>
  );
}
